import { normalizeSupportedLocale, SupportedLocale } from '@sz/l10n';
import { SupportedLocale as SupportedLocaleQGL } from '@/generated/graphql';

export const localeToGQLLocale: { [key in string]: SupportedLocaleQGL } = {
  [SupportedLocale.ENGLISH]: SupportedLocaleQGL.English,
  [SupportedLocale.FRENCH]: SupportedLocaleQGL.French,
  [SupportedLocale.GERMAN]: SupportedLocaleQGL.German,
  [SupportedLocale.ITALIAN]: SupportedLocaleQGL.Italian,
  [SupportedLocale.HUNGARIAN]: SupportedLocaleQGL.Hungarian,
  [SupportedLocale.SPANISH_LATIN_AMERICAN]:
    SupportedLocaleQGL.SpanishLatinAmerican,
  [SupportedLocale.DANISH]: SupportedLocaleQGL.Danish,
  [SupportedLocale.DUTCH]: SupportedLocaleQGL.Dutch,
  [SupportedLocale.INDONESIAN]: SupportedLocaleQGL.Indonesian,
  [SupportedLocale.KOREAN]: SupportedLocaleQGL.Korean,
  [SupportedLocale.MALAY]: SupportedLocaleQGL.Malay,
  [SupportedLocale.TURKISH]: SupportedLocaleQGL.Turkish,
  [SupportedLocale.CHINESE]: SupportedLocaleQGL.Chinese,
  [SupportedLocale.CHINESE_TRADITIONAL]: SupportedLocaleQGL.ChineseTraditional,
  [SupportedLocale.THAI]: SupportedLocaleQGL.Thai,
};

export const getGQLLocaleFromLocale = (locale: string) => {
  // Normalise to the canonical enum value first, so a locale carried by an
  // invite link or direct-invite token in legacy casing (e.g. 'en-gb',
  // 'zh-tw') maps to the right GQL member instead of silently falling back
  // to English. Covers both indirect- and direct-invite signups. (CR-228)
  const normalisedLocale = normalizeSupportedLocale(locale);
  const localeGQL = normalisedLocale
    ? localeToGQLLocale[normalisedLocale]
    : undefined;

  return localeGQL ?? SupportedLocaleQGL.English;
};
